import axios, { AxiosResponse } from 'axios';
import {
  AdminOrganizationAddressDeleteRequest,
  AdminOrganizationAddressListResponse,
  AdminOrganizationAddressSaveRequest,
  AdminOrganizationAddressSaveResponse,
  AdminOrganizationListAllRequest,
  AdminOrganizationListAllResponse,
  AdminOrganizationListRequest,
  AdminOrganizationListResponse,
  AdminOrganizationSaveRequest,
  AdminOrganizationSaveResponse,
} from '@/venit/services/model/techpubs-cms';

export default class OrganizationService {
  public listOrganizations(request: AdminOrganizationListRequest): Promise<AxiosResponse<AdminOrganizationListResponse>> {
    return axios.post<AdminOrganizationListResponse>('/api/admin/users/organizations/list', request);
  }

  public listAllOrganizationNames(request: AdminOrganizationListAllRequest): Promise<AxiosResponse<AdminOrganizationListAllResponse>> {
    return axios.post<AdminOrganizationListAllResponse>('/api/admin/users/organizations/list-all', request);
  }

  public save(request: AdminOrganizationSaveRequest): Promise<AxiosResponse<AdminOrganizationSaveResponse>> {
    return axios.post<AdminOrganizationSaveResponse>('/api/admin/users/organizations/save', request);
  }

  public listOrganizationAddresses(organizationId: number): Promise<AxiosResponse<AdminOrganizationAddressListResponse>> {
    return axios.post<AdminOrganizationAddressListResponse>(`/api/admin/users/organizations/${organizationId}/addresses/list`);
  }

  public saveOrganizationAddress(organizationId: number, request: AdminOrganizationAddressSaveRequest): Promise<AxiosResponse<AdminOrganizationAddressSaveResponse>> {
    return axios.post<AdminOrganizationAddressSaveResponse>(`/api/admin/users/organizations/${organizationId}/addresses/save`, request);
  }

  public deleteOrganizationAddress(organizationId: number, request: AdminOrganizationAddressDeleteRequest): Promise<AxiosResponse<void>> {
    return axios.post<void>(`/api/admin/users/organizations/${organizationId}/addresses/delete`, request);
  }
}
